module.exports = __webpack_public_path__ + "static/media/demo4.6a6dc7a5.jpg";